import React from 'react';
import { io, Socket } from 'socket.io-client';
import Button from '../../components/ui/Button';
import { notificationsService } from '../../services/notificationsService';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://localhost:3402';

const NotificationsPage: React.FC = () => {
  const [items, setItems] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const socketRef = React.useRef<Socket | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await notificationsService.list({ limit: 50, offset: 0 });
      setItems(res.notifications || []);
    } catch (e: any) {
      setError(e?.message || 'Failed to load notifications');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    load();
    const socket = io(SOCKET_URL, { transports: ['websocket'] });
    socketRef.current = socket;
    // In a full implementation, emit authenticate with userId from state
    // socket.emit('authenticate', userId);
    socket.on('notification', (notification) => {
      setItems(prev => [notification, ...prev]);
    });
    return () => { socket.disconnect(); };
  }, []);

  const markAll = async () => {
    await notificationsService.markAllRead();
    await load();
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--patreon-black)' }}>Notifications</h1>
        <Button variant="outline" onClick={markAll}>Mark all as read</Button>
      </div>

      {error && <div className="mb-4 text-sm" style={{ color: 'var(--patreon-error)' }}>{error}</div>}

      {loading ? (
        <div>Loading…</div>
      ) : items.length === 0 ? (
        <div className="p-12 text-center" style={{ background: 'var(--patreon-card-bg)', border: '1px solid var(--patreon-card-border)', borderRadius: 12 }}>
          <p style={{ color: 'var(--patreon-gray)' }}>No notifications yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className="p-4 flex items-start justify-between" style={{ background: 'var(--patreon-card-bg)', border: '1px solid var(--patreon-card-border)', borderRadius: 12 }}>
              <div>
                <div className="font-medium" style={{ color: 'var(--patreon-black)' }}>{n.title || n.type}</div>
                <div className="text-sm" style={{ color: 'var(--patreon-gray)' }}>{n.message}</div>
              </div>
              {!n.isRead && (
                <Button size="sm" variant="outline" onClick={async () => { await notificationsService.markRead(n.id); setItems(prev => prev.map(i => i.id === n.id ? { ...i, isRead: true } : i)); }}>Mark read</Button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;



